<template>
  <!-- Footer Section 06 -->
  <div class="footer-section">
    <!-- Footer -->

    <footer class="page-footer font-small blue pt-4">
      <section class="content-section-02 footer_1">
        <div>
          <div class="row justify-content-center">
            <div class="content-img">
              <img src="../assets/img/section_2.jpg" alt />
              <div class="d-none d-md-block footer_img_text">
                <div class="container" data-aos="zoom-in">
                  <h5>Stay Up to Date</h5>
                  <h4>Subscribe to our newsletter to receive our weekly feed.</h4>
                  <form class="email_sent_feild">
                    <input
                      class="form-control form-control-sm ml-3 w-75"
                      type="text"
                      placeholder="Enter Your Email.."
                      aria-label="Search"
                    />
                  </form>
                  <div class="subscribe_button_b">
                    <a>SUBSCRIBE</a>
                    <span class="getting_line"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Footer Links -->
      <div class="container-fluid text-center text-md-left">
        <!-- Grid row -->
        <div class="row">
          <!-- Grid column -->
          <div class="col-md-5 mt-md-0 mt-3 footer_logo">
            <!-- Content -->
            <a class="navbar-brand nav-item" href="/">
              <img class="logo" src="../assets/img/volunteer2.png" /> volunteer
            </a>
            <h5 class>Help build a world where everyone has a decent place to live.</h5>
          </div>
          <!-- Grid column -->

          <hr class="clearfix w-100 d-md-none pb-3" />

          <!-- Grid column -->
          <div class="col-md-2 mb-md-0 mb-3">
            <!-- Links -->
            <ul class="list-unstyled footer_col_2">
              <li @click="scrollToTop()">
                <!-- <a href="#!">About us</a> -->
                <router-link to="/about-us">About us</router-link>
              </li>
              <li @click="scrollToTop()">
                <!-- <a href="#!">Become Volunteer</a> -->
                <router-link to="/become-volunteer">Become Volunteer</router-link>
              </li>
              <li @click="scrollToTop()">
                <!-- <a href="#!">Events</a> -->
                <router-link to="/events">Events</router-link>
              </li>
              <li @click="scrollToTop()">
                <a href="#!">Publications</a>
              </li>
              <li @click="scrollToTop()">
                <!-- <a href="#!">Info center</a> -->
                <router-link to="/info_center">Info center</router-link>
              </li>
            </ul>
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-md-5 mb-md-0 mb-3 footer_social_all">
            <!-- Links text-uppercase-->
            <h5 class></h5>
            <li class="footer_donate">
              <a>Donate</a>
            </li>
            <div class="flex-center footer_social">
              <!-- Facebook -->
              <a class="fb-ic">
                <i class="fab fa-facebook-f fa-lg white-text mr-md-5 mr-3 fa-2x"></i>
              </a>
              <!--Instagram-->
              <a class="ins-ic">
                <i class="fab fa-instagram fa-lg white-text mr-md-5 mr-3 fa-2x"></i>
              </a>
              <!-- Twitter -->
              <a class="tw-ic">
                <i class="fab fa-twitter fa-lg white-text mr-md-5 mr-3 fa-2x"></i>
              </a>
              <!--Linkedin -->
              <a class="li-ic">
                <i class="fab fa-linkedin-in fa-lg white-text mr-md-5 mr-3 fa-2x"></i>
              </a>
              <!-- Youtube-->
              <a class="gplus-ic">
                <i class="fab fa-youtube fa-lg white-text mr-md-5 mr-3 fa-2x"></i>
              </a>
            </div>
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </div>
      <!-- Footer Links -->

      <!-- Copyright -->
      <div class="footer-copyright text-center py-3">
        <a></a>
      </div>
      <!-- Copyright -->
    </footer>
    <!-- Footer -->
  </div>
</template>
<script>
export default {
  name: "app",
  components: {},

  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
      console.log("check", "top");
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.footer_social {
  font-size: 14px;
}
.router-link-active {
  color: #07cddb !important;
}
.footer_logo img {
  width: auto;
}
.subscribe_button_b .getting_line {
  width: 50px;
  height: 4px;
  background: #ffffff;
  margin-top: 15px;
  position: absolute;
  margin-left: 15px;
}
.footer_img_text {
  position: absolute;
}
.footer_social_all {
  margin-top: 10px;
}
@media screen and (max-width: 2800px) {
  .footer_img_text {
    position: absolute;
    float: left;
    text-align: left;
    left: 140px;
    opacity: 1;
    filter: brightness(1);
  }
  .footer_1 .content-img img {
    filter: brightness(0.6);
  }
  .footer_1 .d-md-block h5 {
    color: #fff;
    font-size: 42px;
    padding-bottom: 10px;
  }
  .footer_1 .d-md-block h4 {
    padding: 10px 0px;
  }
  .footer_1 .form-control-sm {
    height: calc(1.5em + 0.5rem + 2px);
    padding: 20px 40px;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
    height: calc(1.5em + 0.5rem + 2px);
    padding: 25px 10px;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.4rem;
    font-weight: 700;
    color: #000;
  }
  .email_sent_feild {
    width: 80vh;
    padding: 10px 0px;
    margin-left: -15px;
  }
  .subscribe_button_b a {
    color: #fff;
    font-size: 22px;
  }
}
@media screen and (max-width: 1600px) {
  .footer_img_text {
    position: absolute;
    float: left;
    text-align: left;
    left: 110px;
  }
}
@media screen and (max-width: 1400px) {
  .footer_donate {
    margin-right: 25%;
  }
}
@media screen and (max-width: 1280px) {
  .footer_donate {
    margin-right: 22%;
  }
}
@media screen and (max-width: 1200px) {
  .footer_donate {
    margin-right: 10%;
  }
}
@media screen and (max-width: 1024px) {
  .footer_donate {
    margin-right: 0%;
  }
}
@media screen and (max-width: 990px) {
  .footer_img_text {
    position: absolute;
    float: left;
    text-align: left;
    left: 20px;
  }

  .email_sent_feild {
    width: 100%;
    padding: 10px 0px;
    margin-left: -15px;
  }
  .footer_social {
    font-size: 12px;
    width: 110%;
  }
  .footer_social a i {
    margin: 0;
    padding: 0;
    margin-left: -8px;
  }
}
@media screen and (max-width: 990px) {
}
@media screen and (max-width: 767px) {
  .footer_donate a {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
  .footer_social {
    font-size: 12px;
    width: 100%;
  }
  .footer_social a i {
    margin: 8px;
    padding: 0;
    margin-left: 0px;
  }
  .footer-section .text-md-left {
    margin-left: auto;
  }
  .footer_logo a {
    padding-bottom: 50px;
    font-size: 24px;
    margin-left: auto;
  }
  .footer_1 .d-md-block h5 {
    color: #fff;
    font-size: 32px;
    padding-bottom: 10px;
  }
  .d-md-block h4 {
    color: #07cddb;
    font-size: 18px;
    font-weight: 400;
  }
  .footer_1 .form-control-sm {
    height: calc(1.5em + 0.5rem + 2px);
    padding: 20px 40px;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
    height: calc(1.5em + 0.5rem + 2px);
    padding: 20px 10px;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.4rem;
    font-weight: 700;
    color: #000;
  }
}
@media screen and (max-width: 480px) {
  .footer_1 .content-img img {
    height: 40vh;
  }
  .footer_1 .d-md-block h5 {
    color: #fff;
    font-size: 28px;
    padding-bottom: 10px;
  }
  .d-md-block h4 {
    color: #07cddb;
    font-size: 17px;
    font-weight: 400;
  }
  .footer_1 .form-control-sm {
    height: calc(1.5em + 0.5rem + 2px);
    padding: 20px 40px;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
    height: calc(1.5em + 0.5rem + 2px);
    padding: 18px 10px;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.4rem;
    font-weight: 700;
    color: #000;
  }
  .footer_img_text {
    position: absolute;
    float: left;
    text-align: left;
    left: 0px;
  }
  .subscribe_button_b a {
    color: #fff;
    font-size: 18px;
  }
  hr {
    margin-top: 0rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 0px solid rgba(0, 0, 0, 0.1);
  }
  .footer_logo a {
    padding-bottom: 30px;
  }
  .content-section-02 {
    padding: 20px 0 12px;
  }
  .footer_donate {
    padding: 30px 0px;
    list-style: none;
  }
  .footer_social_all {
    margin-top: -20px;
  }
  .pb-3,
  .py-3 {
    padding-bottom: 0rem !important;
    padding-top: 0rem !important;
  }
}
</style>
